var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTodayMenuStoreWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 17.7422H0.703125C0.314812 17.7422 0 18.057 0 18.4453C0 20.128 1.36411 21.4922 3.04688 21.4922H20.9531C22.6358 21.4922 24 20.1281 24 18.4453C24 18.057 23.6852 17.7422 23.2969 17.7422Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 4.75725V4.38281C13.875 3.3473 13.0355 2.50781 12 2.50781C10.9645 2.50781 10.125 3.3473 10.125 4.38281V4.75725C10.7401 4.66467 11.3664 4.61719 12 4.61719C12.6336 4.61719 13.2599 4.66467 13.875 4.75725Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7899 9.24984C17.7093 7.16925 14.9431 6.02344 12.0007 6.02344C9.05831 6.02344 6.29208 7.16925 4.21148 9.24984C2.29753 11.1638 1.17539 13.6582 1.00781 16.3359H22.9935C22.826 13.6582 21.7039 11.1638 19.7899 9.24984Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayMenuStoreWeb);
export default __webpack_public_path__ + "static/media/today-menu-store-web.6176f9ed3b054944a93631987aea6c3e.svg";
export { ForwardRef as ReactComponent };